import { render, staticRenderFns } from "./ProposalAccount.vue?vue&type=template&id=622ef9cc&"
import script from "./ProposalAccount.vue?vue&type=script&lang=js&"
export * from "./ProposalAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports